import React, { FC } from 'react';

import { RequiredRule } from 'devextreme-react/form';

import { AppFieldBox } from 'components/appComponents';
import { SelectBox, Validator } from 'devextreme-react';

import { useGetRequestDestinyQuery } from 'bus/request';

type DensityProps = {
  value: number | null;
  readOnly: boolean;
  onChange: (value: number | null) => void;
};

const Density: FC<DensityProps> = ({ value, readOnly, onChange }) => {
  const { data } = useGetRequestDestinyQuery();

  return (
    <AppFieldBox label="Подвижность" labelTop>
      <SelectBox
        stylingMode="underlined"
        readOnly={readOnly}
        placeholder="Выберите подвижность"
        mode="text"
        value={value}
        onValueChange={onChange}
        displayExpr="name"
        valueExpr="id"
        dataSource={data}
      >
        <Validator>
          <RequiredRule message="Заполните поле подвижность" />
        </Validator>
      </SelectBox>
    </AppFieldBox>
  );
};

export default Density;
